import styled, { css } from "styled-components/native";
import { StyledProps } from "./types";
import { Theme } from "../../../../../theming/types";

export const BetTypeTouchable = styled.TouchableHighlight<StyledProps>`
  height: 100%;
  border-bottom-color: ${({ theme }: { theme: Theme }) =>
    theme.colorTokens.border.default};
  border-bottom-width: 1px;
  padding-left: ${({ theme }: { theme: Theme }) => `${theme.space["space-4"]}`};
  padding-top: ${({ theme }: { theme: Theme }) => `${theme.space["space-5"]}`};
  padding-bottom: ${({ theme }: { theme: Theme }) =>
    `${theme.space["space-5"]}`};
  ${({ isHovered, theme }: StyledProps) =>
    isHovered &&
    css`
      background-color: ${theme.colorTokens.component.button.buttonLink
        .background.hover};
    `}

  ${({ isPressed, theme }: StyledProps) =>
    isPressed &&
    css`
      background-color: ${theme.colorTokens.component.input.pressed};
      border-bottom-color: ${theme.colorTokens.content.link};
      border-bottom-width: 1px;
    `}
  
  ${({ isSelected, theme }: StyledProps) =>
    isSelected &&
    css`
      border-bottom-color: ${theme.colorTokens.content.link};
      border-bottom-width: 1px;
    `}

  ${({ isHovered, isSelected, isParentHovered, theme }: StyledProps) =>
    !isHovered &&
    isSelected &&
    !isParentHovered &&
    css`
      background-color: ${theme.colorTokens.component.button.buttonLink
        .background.hover};
    `}
`;

export const BetTypeText = styled.Text<StyledProps>`
  color: ${({ theme }: StyledProps) => theme.colorTokens.content.default};
  font-family: ${({ theme }: StyledProps) => theme.fonts.medium};
  font-size: ${({ theme }: StyledProps) => theme.fontSizes.s};
  ${({ isSelected, isPressed, theme }: StyledProps) =>
    (isSelected || isPressed) &&
    css`
      color: ${theme.colorTokens.content.link};
    `};
`;
